import { render, staticRenderFns } from "./ImageTable.vue?vue&type=template&id=0954fdce&scoped=true"
import script from "./ImageTable.vue?vue&type=script&lang=js"
export * from "./ImageTable.vue?vue&type=script&lang=js"
import style0 from "./ImageTable.vue?vue&type=style&index=0&id=0954fdce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0954fdce",
  null
  
)

export default component.exports